import { isNumber } from 'lodash';

export const toPercentage = (
	value: number,
	total: number,
	{
		digits = 0,
		preTransform = v => v,
		postTransform = v => v,
	}: {
		digits?: number;
		preTransform?(v: number): number;
		postTransform?(v: number): number;
	} = {}
) => {
	if (!isNumber(value) || !isNumber(total) || total === 0) {
		return 0;
	}

	// (value / total) * 100
	const ratio = value / total;

	const preValue = preTransform(ratio);

	const percentage = preValue * 100;

	const percentageFixed = percentage.toFixed(digits);

	const postValue = postTransform(Number(percentageFixed));

	return postValue;
};
